"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var IconTeach = function IconTeach(_ref) {
  var style = _ref.style,
      className = _ref.className;
  return _react.default.createElement("svg", {
    width: "16px",
    height: "16px",
    className: (0, _classnames.default)('Icon', 'IconTeach', className),
    style: style,
    viewBox: "0 0 16 16"
  }, _react.default.createElement("path", {
    fillRule: "evenodd",
    d: "M6.734 10.947c1.437 0 2.607 1.103 2.607 2.471v.89c0 .385-.326.692-.721.692-.396 0-.722-.307-.722-.693v-.889c0-.597-.518-1.086-1.164-1.086H2.963c-.646 0-1.164.489-1.164 1.086v.89c0 .385-.326.692-.722.692-.395 0-.72-.307-.72-.693v-.889c0-1.368 1.169-2.471 2.606-2.471h3.771zM14.182 1C15.186 1 16 1.804 16 2.795v8.615c0 .992-.814 1.795-1.818 1.795h-2.9a.723.723 0 0 1-.728-.718c0-.396.326-.718.727-.718h2.9c.202 0 .364-.16.364-.359V2.795a.361.361 0 0 0-.363-.36H1.939a.482.482 0 0 0-.484.48v2.512a.723.723 0 0 1-.728.718A.723.723 0 0 1 0 5.427V2.915C0 1.857.868 1 1.94 1zM4.848 5c1.477 0 2.675 1.172 2.675 2.62 0 1.447-1.198 2.62-2.675 2.62-1.476 0-2.674-1.173-2.674-2.62C2.174 6.172 3.372 5 4.848 5zm0 1.444c-.665 0-1.204.527-1.204 1.176 0 .648.539 1.175 1.204 1.175.666 0 1.205-.527 1.205-1.175 0-.649-.539-1.176-1.205-1.176z"
  }));
};

var _default = IconTeach;
exports.default = _default;